import { useCallback, useState } from 'react';
import { useModal } from '../../Modal/hooks/useModal';
import isEmpty from 'lodash/isEmpty';
import { useEvent } from './useEvent';
export var useCreatePreset = function (_a) {
    var gridName = _a.gridName, filters = _a.filters, onClosePresetsModal = _a.onClosePresetsModal, setSelectedPresetName = _a.setSelectedPresetName, gridActions = _a.gridActions;
    var _b = useModal(), isCreatePresetModalOpen = _b.isOpen, onOpenCreatePresetModal = _b.onOpen, onCloseCreatePresetModal = _b.onClose;
    var _c = useState(''), presetName = _c[0], setPresetName = _c[1];
    var handleChangePresetName = useCallback(function (event) {
        setPresetName(event.target.value);
    }, []);
    var handleCloseCreatePresetModal = useCallback(function () {
        setPresetName('');
        onCloseCreatePresetModal();
    }, []);
    var handleCreatePreset = useEvent(function () {
        var _a;
        setPresetName('');
        onCloseCreatePresetModal();
        onClosePresetsModal();
        if (isEmpty(filters) || !gridName)
            return;
        (_a = gridActions.createPreset) === null || _a === void 0 ? void 0 : _a.call(gridActions, presetName, filters);
        setSelectedPresetName(presetName);
    });
    return {
        isCreatePresetModalOpen: isCreatePresetModalOpen,
        onOpenCreatePresetModal: onOpenCreatePresetModal,
        handleCloseCreatePresetModal: handleCloseCreatePresetModal,
        presetName: presetName,
        handleChangePresetName: handleChangePresetName,
        handleCreatePreset: handleCreatePreset
    };
};
